import { OpeningHours, ShopEvent } from '../types/content';

export const contact = {
  shopName: 'Trip Ink Tattoo Company',
  phoneMain: '702-605-6633',
  phoneWalkIn: '702-586-5308',
  phoneText: '702-408-8305',
  email: 'tripinklv@gmail.com',
  addressLine1: '5115 Dean Martin Drive #906',
  addressLine2: 'Las Vegas, NV 89118',
  addressNote: 'Front entrance to Hot Rod City',
  instagram: 'https://www.instagram.com/tripinktattoo/',
  facebook: 'https://www.facebook.com/tripinktattoo/',
  youtube: 'https://www.youtube.com/results?search_query=trip+ink+tattoo+las+vegas',
};

export const walkInNotice =
  'Call 702-605-6633/702-586-5308 to ask for walk-in availability. And walk-ins are welcome most every day! To schedule, text 702-605-6633/702-408-8305, or email tripinklv@gmail.com.';

export const hoursDisclaimer =
  'These hours may vary day to day, with appointments being available or made earlier or later, than the hours mentioned above. Please call our shop directly at 702-605-6633, to see if an artist is available for appointments or for walk-ins, before we open or even after we close.';

export const openingHours: OpeningHours[] = [
  { day: 'Monday', hours: '12pm > 8pm' },
  { day: 'Tuesday', hours: '12pm > 8pm' },
  { day: 'Wednesday', hours: '12pm > 8pm' },
  { day: 'Thursday', hours: '1pm > 10pm' },
  { day: 'Friday', hours: '1pm > 10pm' },
  { day: 'Saturday', hours: '1pm > 10pm' },
  { day: 'Sunday', hours: '1pm > 10pm' },
];

export const navLeft = [
  { to: '/', label: 'Home' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/artists', label: 'Artists' },
  { to: '/shop', label: 'Shop' },
];

export const navRight = [
  { to: '/book-now', label: 'Book Now' },
  { to: '/release-form', label: 'Release Form' },
  { to: '/blog', label: 'Blog' },
  { to: '/videos', label: 'Videos' },
];

export const shopEvents: ShopEvent[] = [
  { date: 'March 13th', text: 'Join us for an open house event to explore our facilities and meet the team.' },
  { date: 'March 17th', text: 'Celebrate St. Patrick’s Day with us! Enjoy themed activities and special offers.' },
];
